import { LinearProgress } from 'react-admin';
import { CardContent, Typography } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { GreenChip, YellowChip } from './shared';
import { useNativeLineItem } from './forms/hooks/useNativeLineItem';

/**
 * Legacy `/line_items/:id/show` route (MD-5186 Phase A/B).
 * Thin redirect shell — no Placements REST provider. Resolves native UUID via
 * GraphQL and sends bookmarks to `/lineItems/<uuid>/show`.
 */
export const LineItemShow = () => {
  const { id } = useParams();
  const { lineItem, isLoading, error } = useNativeLineItem(id);

  if (!id) return null;
  if (isLoading) return <LinearProgress />;
  if (lineItem?.id) {
    return <Navigate to={`/lineItems/${encodeURIComponent(String(lineItem.id))}/show`} replace />;
  }

  const errorMessage = error instanceof Error ? error.message : undefined;
  return (
    <CardContent>
      <Typography color="error">{errorMessage ?? `Line item not found for id ${id}`}</Typography>
    </CardContent>
  );
};

/** Approved/draft status chip shared by creative datagrids (native LineItemShow, lead-gen). */
export const Chip = ({ isApproved }: { isApproved: boolean }) => {
  return isApproved ? <GreenChip /> : <YellowChip />;
};
